import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addressList } from '@/api/personal-center';


export interface Address {
  name: string;
  tel: string;
  detailAddress: string;
  defaultStatus: number;
  id: number;
}


interface AddressState {
  addressesList: Address[];
  // 新增/编辑弹窗
  editModalState: {
    title: string;
    isAdd: boolean;
    open: boolean;
    id: string;
  };
  // 删除弹窗
  deleteModalState: {
    open: boolean;
    id: string;
  };
  selectedAddressId:number|undefined
}

// 定义异步 action
export const getAddressList = createAsyncThunk('addressReducer/getAddressList', async (_, { rejectWithValue }) => {
  try {
    const response:any = await addressList(); // 调用 API 获取地址列表
    return response.obj; // 返回获取到的地址列表
  } catch (error) {
    return rejectWithValue(error); // 如果出错，返回错误信息
  }
});

const initialState: AddressState = {
  addressesList: [],
  editModalState: {
    title: '',
    isAdd: true,
    open: false,
    id: '',
  },
  deleteModalState: {
    open: false,
    id: '',
  },
  // 维护一个本次选中的地址
  selectedAddressId: undefined,
};

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setDeleteModalState: (state, action: PayloadAction<{ open: boolean; id: string }>) => {
      state.deleteModalState = action.payload;
    },
    setEditModalState: (state, action: PayloadAction<{ title: string; isAdd: boolean; open: boolean; id: string }>) => {
      state.editModalState = action.payload;
    },
    setSelectedAddressId: (state, action: PayloadAction<number>) => {
      state.selectedAddressId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // 处理 getAddressList 的 pending 状态
      .addCase(getAddressList.pending, (state) => {
        // 可以在这里设置 loading 状态
      })
      // 处理 getAddressList 的 fulfilled 状态
      .addCase(getAddressList.fulfilled, (state, action) => {
        state.addressesList = action.payload.sort((a: { defaultStatus: 0 | 1 }, b: { defaultStatus: 0 | 1 }) => {
          if (a.defaultStatus === 1) return -1; 
          if (b.defaultStatus === 0) return 1; 
          return 0; 
        }); 
      })
      // 处理 getAddressList 的 rejected 状态
      .addCase(getAddressList.rejected, (state, action) => {
        // 可以在这里处理错误状态
        console.error('Failed to fetch address list:', action.payload);
      });
  },
});
export const { setDeleteModalState, setEditModalState, setSelectedAddressId } = addressSlice.actions;
export default addressSlice.reducer;
